var working = false;
var callback;
var callbacks = [];

var completed = false;
var _err, _mainPlayer;

module.exports = function(cb){
	if (completed) {
		cb && cb(_err, _mainPlayer);
		return;
	}
	cb && callbacks.push(cb);
	if (!working) {
		working = true;

		require("./FullAccessAccount.js")(mainPlayer);
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event': 'ImageLink',
			'event_category': 'overVideoPlayer',
			'event_label': 'StartVideo'
		});
		while(callback = callbacks.pop()) {
			callback(_err, _mainPlayer);
		}
		working = false;
		completed = true;
	}
};